export function pageView(pathname) {
  if (typeof ga === 'function') {
    ga('send', 'pageview', pathname);
  }
}


// WEBPACK FOOTER //
// ./src/js/util/tracking/GoogleAnalytics.js